import { ReactNode } from 'react';

interface AdminAccordionSectionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
}

const AdminAccordionSection = ({ title, isOpen, onToggle, children }: AdminAccordionSectionProps) => {
  return (
    <section className='admin-section'>
      <button className='admin-section-header' type='button' onClick={onToggle} aria-expanded={isOpen}>
        <span className={`pi ${isOpen ? 'pi-angle-down' : 'pi-angle-right'}`} aria-hidden='true' />
        <span>{title}</span>
      </button>
      {isOpen && <div className='admin-section-body'>{children}</div>}
    </section>
  );
};

export default AdminAccordionSection;
